import styled, { css } from 'styled-components';

import { TThemeShadows } from '@pb/styles';
import { TCardSharedStyles } from './card.types';

const CardSharedStyles = css<TCardSharedStyles>`
    display: ${({ fillWidth }) => (fillWidth ? 'block' : 'inline-block')};
    height: ${({ fillHeight }) => (fillHeight ? '100%' : 'auto')};
    overflow: hidden;
    color: ${({ backgroundColor, theme }) =>
        backgroundColor === 'indigo' ? theme.color.white : theme.color.grey7};
    background: ${({ backgroundColor, theme }) => theme.color[backgroundColor]};
    border: 0.1rem solid ${({ theme }) => theme.color.grey3};
    border-radius: ${({ theme }) => theme.borderRadius.default};
`;

export const StyledCard = styled.div<TCardSharedStyles>`
    ${CardSharedStyles}
    ${({ showStyles }) =>
        !showStyles &&
        css`
            border: 0;
            background: transparent;
        `}
`;

export const StyledCardLink = styled.a<TCardSharedStyles>`
    ${CardSharedStyles};
    text-decoration: none;
    outline: 0.2rem solid transparent;
    outline-offset: 0.3rem;
    transition: all ease-in-out 0.3s;

    &:hover,
    &:focus {
        border-color: ${({ theme }) => theme.color.grey6};
        box-shadow: ${({ theme, shadow }) =>
            theme.shadow[shadow as TThemeShadows]};
    }

    &:focus {
        outline-color: ${({ theme }) => theme.color.purple};
    }
`;
